import { render, staticRenderFns } from "./AttorneyOfRecord.vue?vue&type=template&id=545fe6a6&scoped=true&"
import script from "./AttorneyOfRecord.vue?vue&type=script&lang=js&"
export * from "./AttorneyOfRecord.vue?vue&type=script&lang=js&"
import style0 from "./AttorneyOfRecord.vue?vue&type=style&index=0&id=545fe6a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545fe6a6",
  null
  
)

export default component.exports